<datex-grid #$gridComponent *ngIf="initialized && !$hasMissingRequiredInParams" [selection]="true" (selectionChange)="$selectionChanged($event)" [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"
[canEdit]="canEdit"
[canAdd]="canAdd" [addNewRowFn]="addRow.bind(this)" [addLineModel]="bottomToolbar.addLine"

[rowCommandTemplateRef]="rowCommand">
    <ng-template #rowCommand let-row>
      <div mat-menu-item class="grid-row-options">
        <button mat-menu-item
                class="datex-button"
                [disabled]="row.options.on_instructions_clicked.readOnly"
                [ngStyle]="row.options.on_instructions_clicked.styles.style"
                [ngClass]="row.options.on_instructions_clicked.styles.classes"
                (click)="row.on_row_instructions_clicked()">
          <span *ngIf="row.options.on_instructions_clicked.label">{{row.options.on_instructions_clicked.label}}</span>
        </button>
      </div>
    </ng-template>
    <ng-container topToolbar>
      <app-toolbar [toolbar]="topToolbar">
          <ng-template 
            toolbarToolDef="on_delete" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <button mat-button
                    data-cy="button"
                    class="datex-button"
                    [disabled]="tool.control.readOnly || tool.control.disabled"
                    [ngStyle]="tool.control.styles.style"
                    [ngClass]="tool.control.styles.classes"
                    [matTooltip]="tool.control.tooltip"
                    matTooltipClass="datex-control-tooltip"
                    (click)="on_delete($event)"
                    >
              <div class="button-label">
                <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                  <div class="button-icon">
                    <i data-cy="button-icon" class="datex-default-spinner"></i>
                  </div>
                </ng-container>
                <ng-template #showIcon>
                  <div class="button-icon">
                    <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                  </div>
                </ng-template>
                <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
              </div>
            
            </button>
            </ng-container>
          </ng-template>
      </app-toolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch"
        matTooltipClass="datex-control-tooltip">
    </div>
  </ng-container>


  <ng-container gridColumnDef="servicetype_name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.servicetype_name.displayControl.styles.style"
          [ngClass]="row.cells.servicetype_name.displayControl.styles.classes"
          [matTooltip]="row.cells.servicetype_name.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.servicetype_name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <Carriers-carrierservicetypes_excl_carrier_dd_single 
        data-cy="selector"
        [type]="row.cells.servicetype_name.editControl.type"
        [formControl]="row.formGroup.controls['servicetype_name_edit']"
        (displayTextChange)="row.cells.servicetype_name.editControl.displayText=$event"
        [placeholder]="row.cells.servicetype_name.editControl.placeholder"
        [styles]="row.cells.servicetype_name.editControl.styles"
        [tooltip]="row.cells.servicetype_name.editControl.tooltip"
      [carrierId]="row.$fields_servicetype_name_selector_inParams_carrierId"
    >
    </Carriers-carrierservicetypes_excl_carrier_dd_single>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="service_mode">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.service_mode.displayControl.styles.style"
          [ngClass]="row.cells.service_mode.displayControl.styles.classes"
          [matTooltip]="row.cells.service_mode.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.service_mode.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['service_mode_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.service_mode.editControl.readOnly || row.cells.service_mode.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.service_mode.editControl.placeholder}}"
            [ngStyle]="row.cells.service_mode.editControl.styles.style"
            [ngClass]="row.cells.service_mode.editControl.styles.classes"
            [matTooltip]="row.cells.service_mode.editControl.tooltip"
            matTooltipClass="datex-control-tooltip"> 
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="service_type">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.service_type.displayControl.styles.style"
          [ngClass]="row.cells.service_type.displayControl.styles.classes"
          [matTooltip]="row.cells.service_type.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.service_type.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['service_type_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.service_type.editControl.readOnly || row.cells.service_type.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.service_type.editControl.placeholder}}"
            [ngStyle]="row.cells.service_type.editControl.styles.style"
            [ngClass]="row.cells.service_type.editControl.styles.classes"
            [matTooltip]="row.cells.service_type.editControl.tooltip"
            matTooltipClass="datex-control-tooltip"> 
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="service_group">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.service_group.displayControl.styles.style"
          [ngClass]="row.cells.service_group.displayControl.styles.classes"
          [matTooltip]="row.cells.service_group.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.service_group.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['service_group_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.service_group.editControl.readOnly || row.cells.service_group.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.service_group.editControl.placeholder}}"
            [ngStyle]="row.cells.service_group.editControl.styles.style"
            [ngClass]="row.cells.service_group.editControl.styles.classes"
            [matTooltip]="row.cells.service_group.editControl.tooltip"
            matTooltipClass="datex-control-tooltip"> 
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="service_class">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.service_class.displayControl.styles.style"
          [ngClass]="row.cells.service_class.displayControl.styles.classes"
          [matTooltip]="row.cells.service_class.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.service_class.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['service_class_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.service_class.editControl.readOnly || row.cells.service_class.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.service_class.editControl.placeholder}}"
            [ngStyle]="row.cells.service_class.editControl.styles.style"
            [ngClass]="row.cells.service_class.editControl.styles.classes"
            [matTooltip]="row.cells.service_class.editControl.tooltip"
            matTooltipClass="datex-control-tooltip"> 
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
<div *ngIf="$hasMissingRequiredInParams" class="missing-params">
  <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
</div>
